<!-- begin breadcrumb -->
<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración</li>
    <li class="breadcrumb-item active">Capitales</li>
</ol>
<!-- end breadcrumb -->
<!-- begin page-header -->
<h1 class="page-header"><i class="fas fa-wrench"></i> Administración <small> Capitales</small></h1>
<!-- end page-header -->

<div class="panel">
    <div class="panel-body">
        <div class="row" [formGroup]="newPositionForm">

            <div class="col-md-3">
                Selección periodo
                <ng-select placeholder="Seleccione un periodo" class="ng-select-sm" [items]="listPeriods"
                    formControlName="year" (change)="getPositions()"></ng-select>
            </div>
            <div class="col-md-3">
                Tipo de Entidad
                <ng-select placeholder="Seleccione un periodo" class="ng-select-sm" [items]="listTypesCampus"
                    bindLabel="name" bindValue="_id" formControlName="typeCampusId"
                    (change)="getPositions()"></ng-select>
            </div>
            <div class="col-md-6 d-flex justify-content-end align-items-center">
                <button class="btn btn-primary btn-sm" (click)="open(modalPosition)">Nuevo Cargo</button>
            </div>
        </div>


        <div class="row">
            <div class="mt-4">
                <div class="table-responsive">
                <table class="table table-sm table-striped table-hover">
                    <thead>
                        <tr>
                            <th>N°</th>
                            <th>Cargo</th>
                            <th class="text-center">FMR</th>
                            <th class="text-center">Capital en UF</th>
                            <th class="text-center"><i class="fas fa-cogs"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(position of listPositions; track position){
                        <tr>
                            <td>{{$index + 1}}</td>
                            <td>{{position.name}}</td>
                            <td class="text-center">{{position.fmr}}</td>
                            <td class="text-center">{{position.totalUF}}</td>
                            <td class="text-center">
                                <button class="btn btn-outline-primary btn-xs"
                                    (click)="openEditModal(modalPosition, position)">
                                    <i class="fas fa-edit"></i>
                                </button>
                            </td>
                            }
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-footer" hidden=""></div>
</div>

<ng-template #modalPosition let-c="close" let-d="dismiss">
    <div class="modal-header">
        <span class="fs-3 fw-700">Datos del Cargo</span>
    </div>
    <div class="modal-body" [formGroup]="newPositionForm">
        <div class="row py-3">

            <div class="col-md-4">
                <label class="form-label col-form-label col-md-3">Nombre</label>
                <input type="text" class="form-control" placeholder="Nombre del cargo" formControlName="name" />
            </div>
            <div class="col-md-4">
                <label class="form-label col-form-label col-md-3">FMR</label>
                <input type="text" class="form-control" placeholder="FMR del cargo" formControlName="fmr" />
            </div>
            <div class="col-md-4">
                <label class="col-form-label col-md-3 text-no-wrap">Capital en UF</label>
                <input type="text" class="form-control" placeholder="Capital en UF" formControlName="totalUF" />
            </div>
        </div>

    </div>

    <div class="modal-footer">
        <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
        <button class="btn btn-primary" (click)="d('Cross click'); savePosition()">Guardar</button>
    </div>
</ng-template>